import { Trans } from 'react-i18next';

export const RepairHistoryLabel = (key = 'shared.listingCard.repairHistory.label') => (
  <Trans i18nKey={key} components={{ strong: <strong /> }} />
);

export default RepairHistoryLabel;
